export default __webpack_public_path__ + "static/media/7.1dd0a35d.png";